import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

//User views
import candidateWelcome from "@/views/candidate/welcome/index.vue";

//Main layouts
import adminLayout from "@/layouts/admin-layout.vue";
import candidateLayout from "@/layouts/candidate-layout.vue";

//Admin views
import adminHome from "@/views/admin/admin-home.vue";
import adminUsers from "@/views/admin/users/admin-users.vue";
import adminUserSingle from "@/views/admin/users/admin-user-single.vue";
import adminTests from "@/views/admin/tests/index.vue";
import adminTestsAll from "@/views/admin/tests/tests-all.vue";
import adminTestSingle from "@/views/admin/tests/test-single.vue";

import adminFunnels from "@/views/admin/funnels/index.vue";

import adminTags from "@/views/admin/tags/tags-all.vue";
import adminAdministrators from "@/views/admin/admin-administrators.vue";

//Candidate views
import candidateHome from "@/views/candidate/home/";
import candidateVacancies from "@/views/candidate/vacancies/";
import candidateTests from "@/views/candidate/testing/";
import candidateProfile from "@/views/candidate/profile/";
import candidateTestSingle from "@/views/candidate/testing/test-single.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      rule: "anonymous",
    },
  },
  {
    path: "/admin",
    redirect: "/admin/funnels",
    component: adminLayout,
    meta: {
      rule: "admin",
      requiresAuth: true,
    },
    children: [
      {
        path: "home",
        name: "admin-home",
        redirect: "funnels",
        component: adminHome,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
      {
        path: "users",
        name: "admin-users",
        component: adminUsers,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
      {
        path: "users/:id",
        name: "admin-user-single",
        component: adminUserSingle,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
      {
        path: "tests",
        name: "admin-tests",
        redirect: "/admin/tests/all",
        component: adminTests,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
        children: [
          {
            path: "all",
            name: "tests-all",
            component: adminTestsAll,
            meta: {
              rule: "admin",
              requiresAuth: true,
            },
          },
          {
            path: ":id",
            name: "test-single",
            component: adminTestSingle,
            meta: {
              rule: "admin",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "funnels",
        name: "funnels",
        component: adminFunnels,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
      {
        path: "tags-and-categories",
        name: "admin-tags",
        component: adminTags,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
      {
        path: "administrators",
        name: "admin-administrators",
        component: adminAdministrators,
        meta: {
          rule: "admin",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/welcome",
    component: candidateWelcome,
    meta: {
      rule: "anonymous",
      requiresAuth: false,
    },
  },
  {
    path: "/u",
    redirect: "/u/my",
    component: candidateLayout,
    meta: {
      rule: "user",
      requiresAuth: true,
    },
    children: [
      {
        path: "my",
        name: "candidate-home",
        component: candidateHome,
        meta: {
          rule: "user",
          requiresAuth: true,
        },
      },
      {
        path: "my/profile",
        name: "candidate-profile",
        component: candidateProfile,
        meta: {
          rule: "user",
          requiresAuth: true,
        },
      },
      {
        path: "my/vacancies",
        name: "candidate-vacancies",
        component: candidateVacancies,
        meta: {
          rule: "user",
          requiresAuth: true,
        },
      },
      {
        path: "my/tests",
        name: "candidate-tests",
        component: candidateTests,
        meta: {
          rule: "user",
          requiresAuth: true,
        },
      },
      {
        path: "my/tests/:id",
        name: "candidate-test-single",
        component: candidateTestSingle,
        meta: {
          rule: "user",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: {
      rule: "anonymous",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
